import React, { useEffect, useRef, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Invoices from './components/Invoices';
import Payment from './components/Payment';
import { SharedProvider } from './context';
import ProtectedRoute from './ProtectedRoute';
import axios from 'axios';

const RedirectToLogin = () => <Navigate to="/login" />;

const App = () => {
  const fetchedRef = useRef(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;

    const fetchData = async (code) => {
      const companyName = process.env.REACT_APP_COMPANY;
      try {
        await axios.get(`${process.env.REACT_APP_API_URL}/l/${companyName}/${code}`);
      } catch (err) {
        console.error('Erro ao buscar dados:', err);
      } finally {
        setIsLoading(false); // Libera o carregamento das rotas
      }
    };
    
    const params = new URLSearchParams(window.location.search);
    if (params.has('cupom')) {
      localStorage.setItem('cupom', params.get('cupom'));
    }
    if (params.has('c')) {
      fetchData(params.get('c'));
    } else {
      setIsLoading(false); // Nenhum código => já pode liberar as rotas
    }
  }, []);

  if (isLoading) {
    return <div>Carregando...</div>; // ou um Spinner bonito
  }

  return (
    <SharedProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/invoices"
            element={
              <ProtectedRoute>
                <Invoices />
              </ProtectedRoute>
            }
          />
          <Route
            path="/payment"
            element={
              <ProtectedRoute>
                <Payment />
              </ProtectedRoute>
            }
          />
          <Route path="" element={<RedirectToLogin />} />
          <Route path="/" element={<RedirectToLogin />} />
        </Routes>
      </Router>
    </SharedProvider>
  );
};

export default App;
